"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var provider_1 = require("../../../theme/provider");
var titleUtils_1 = require("../../../utils/components/primitives/titleUtils");
var utils_1 = require("../../../utils/utils");
var SharedHeaderStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: ", ";\n  font-weight: bold;\n  font-size: ", ";\n  line-height: 125%;\n  &,\n  & > * {\n    color: ", ";\n  }\n"], ["\n  margin: 0;\n  padding: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: ", ";\n  font-weight: bold;\n  font-size: ", ";\n  line-height: 125%;\n  &,\n  & > * {\n    color: ", ";\n  }\n"])), function (props) { return (0, provider_1.getFontFromTheme)(props.theme).fontFamily; }, function (props) { return (0, titleUtils_1.setFontSizeByHeaderLevel)(props.level, props.mobile); }, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.white, theme.textColor);
});
var StyledHeader = styled_components_1.default.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), SharedHeaderStyles);
var Title = function (props) {
    var _a;
    var children = props.children, _b = props.level, level = _b === void 0 ? 1 : _b, _c = props.mobile, mobile = _c === void 0 ? false : _c, as = props.as, _d = props.className, className = _d === void 0 ? "" : _d;
    var tagName = (_a = as) !== null && _a !== void 0 ? _a : "h".concat(level);
    return ((0, jsx_runtime_1.jsx)(StyledHeader, __assign({ as: tagName, level: level, mobile: mobile }, props, { className: "wellms-component ".concat(className) }, { children: children })));
};
exports.Title = Title;
// https://styled-components.com/docs/api#using-custom-props
var NewTitle = (0, styled_components_1.default)(exports.Title)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), SharedHeaderStyles);
// Main button with styles
exports.default = (0, styled_components_1.withTheme)(NewTitle);
var templateObject_1, templateObject_2, templateObject_3;
